module.exports = __webpack_public_path__ + "@/assets/img/jpg.36dcc70f.svg";